/* eslint-disable prefer-template */
import PropTypes, { any } from 'prop-types';
import React from 'react';

import { EventTypes } from '../../../utils/clubs';
import { LeagueGenderValues } from '../../../utils/eventConstants';
import Filter, { FilterModal, FilterSection } from './Filter';
import ButtonFilter from './FilterComponents/CoreComponents/ButtonFilter';

import styles from '../search.scss';

const GenderFilter = (props) => {
    const { type = '', filters, filterModal, handleFilterClick, closeModals, filterInputs, handleFilterUpdate, mobileOnly, desktopOnly, showCoedOption, showMixedOption, maleCount, femaleCount, mixedCount, coedCount, customOptions, 'data-testid': dataTestId } = props;
    const { ALL, CO_ED, FEMALE, MALE, MIXED } = LeagueGenderValues;

    let options = [
        { label: `All`, value: ALL },
        { label: `Male${maleCount ? ' (' + maleCount + ')' : ''}`, value: MALE },
        { label: `Female${femaleCount ? ' (' + femaleCount + ')' : ''}`, value: FEMALE },
    ];

    if (type === EventTypes.LEAGUES || showCoedOption) {
        options = [...options, { label: `Co-ed${coedCount ? ' (' + coedCount + ')' : ''}`, value: CO_ED }];
    }
    if (showMixedOption) {
        options = [...options, { label: `Mixed${mixedCount ? ' (' + mixedCount + ')' : ''}`, value: MIXED }];
    }

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'gender'}
                searchFor={type}
                handleFilterClick={handleFilterClick}
                isActive={(filters && filters.gender) || filterModal === 'gender'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                <div className={styles.flexContainer}>
                    <span className={styles.textStyle}>
                        {type === 'collegeCorner' && filters && !filters.gender ? 'All genders ' : 'Gender '}
                        {filters.gender ? `: ${filters.gender}` : ''}
                    </span>
                    {type !== 'collegeCorner' && <i className={`uts uts-expand ${styles.iconStyle}`} />}
                </div>
            </Filter>
            {filterModal === 'gender' && (
                <FilterModal
                    title={'Gender'}
                    onCloseClick={closeModals}
                    style={options.length === 5 ? { width: '500px' } : {}}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <ButtonFilter
                            options={customOptions !== null ? customOptions : options}
                            selected={filterInputs.gender}
                            onClick={(gender) => {
                                handleFilterUpdate({
                                    gender,
                                }, 'submit');
                            }}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />

                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

GenderFilter.propTypes = {
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    customOptions: PropTypes.objectOf(any),
    type: PropTypes.string,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    showCoedOption: PropTypes.bool,
    showMixedOption: PropTypes.bool,
    maleCount: PropTypes.number,
    femaleCount: PropTypes.number,
    mixedCount: PropTypes.number,
    coedCount: PropTypes.number,
    'data-testid': PropTypes.string,
};
GenderFilter.defaultProps = {
    type: '',
    handleFilterClick: () => { },
    closeModals: () => { },
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    showCoedOption: false,
    showMixedOption: false,
    maleCount: null,
    femaleCount: null,
    mixedCount: null,
    coedCount: null,
    customOptions: null,
    'data-testid': undefined,
};

export default GenderFilter;
